export default "__VITE_ASSET__Ch5WbJ1K__"